// extracted by mini-css-extract-plugin
export default {"root":"IconFarmShop_root__LnS+i"};